import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Sidebar from "../sidebar"
import Footer from "../footer"
import "./global.css"
import "./web-grid.css"

import styles from "./layout.module.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
	<React.Fragment>
		<div className={styles.container}>
			<input id="nav-input" type="checkbox" className="nav-unshown" />
			<label className={styles.burgur_menu} htmlFor="nav-input">
				<span className={styles.icon_menu}></span>
			</label>

			<div className={styles.sidebar}>
				<Sidebar siteTitle={data.site.siteMetadata.title} />
			</div>

			<div className={styles.main}>
				{children}
				<Footer />
			</div>
		</div>
	</React.Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
